let locale = 'en';

function sort(a, b) {
  if (a.label.localeCompare) {
    return a.label.localeCompare(b.label, locale, { sensitivity: 'base' });
  }

  if (a.label === b.label) {
    return 0;
  }

  return (a.label < b.label) ? -1 : 1;
}

function alphasort_options(items) {
  if (
    this.context
    && this.context.config
    && this.context.config.language
  ) {
    locale = this.context.config.language;
  }

  items.sort(sort);

  return items;
}

module.exports = alphasort_options;



// WEBPACK FOOTER //
// ./src/libs/twig/alphasort_options/index.js